import { render } from "./SortTabs.vue?vue&type=template&id=657b906c&scoped=true"
import script from "./SortTabs.vue?vue&type=script&lang=js"
export * from "./SortTabs.vue?vue&type=script&lang=js"

import "./SortTabs.vue?vue&type=style&index=0&id=657b906c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-657b906c"]])

export default __exports__